import React from 'react';
import UserMenu from './UserMenu';
import NotificationDropdown from './NotificationDropdown';

const NavbarHeader = ({ onToggleSidebar }) => {

  return (
    <header className="navbar navbar-expand-md d-print-none">
      <div className="container-fluid">
        <a onClick={onToggleSidebar}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-menu-2">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 6l16 0" />
            <path d="M4 12l16 0" />
            <path d="M4 18l16 0" />
          </svg>
        </a>
        <div className="navbar-nav flex-row order-md-last">
          <NotificationDropdown />
          <UserMenu />
        </div>
      </div>
    </header>
  );
};

export default NavbarHeader;
